import { GET } from './api';

const table = 'envio-reguas';

export const ReadDunningByCobranca = async (id, filters = '') => {
  return await GET(
    `/${table}?filters[cobranca][id][$eq]=${id}${filters}`,
    true
  );
};

export const ReadDunningByTitulo = async (id, filters = '') => {
  return await GET(`/${table}?filters[titulo][id][$eq]=${id}${filters}`, true);
};

// Historico da pessoa: atravessa todos os contratos do cliente, como o
// ReadByCliente de tentativa-cobranca. O envio-regua tem a relacao com cliente
// mesmo sem traze-la populada na listagem.
export const ReadDunningByCliente = async (id, filters = '') => {
  return await GET(`/${table}?filters[cliente][id][$eq]=${id}${filters}`, true);
};
